import * as React from 'react';
import { PasskeyContext } from '@contexts/passkey/PasskeyContext';

export const usePasskeyContext = () => React.useContext(PasskeyContext);
